import { reatomAsync, withDataAtom } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { API } from "src/api.ts";
import { withDebounce, withIsLoadingAtom } from "src/common/pipes";

import { ordersFiltersAtom } from "../atom";

export const getOrdersWithFilters = reatomAsync(async (ctx) => {
  const filters = ctx.get(ordersFiltersAtom);

  const params = {
    page: filters.page,
    limit: filters.pageSize,
  };

  return API.orderApi
    .orderControllerGetOrders(params, {
      signal: ctx.controller.signal,
    })
    .then((response) => response.data);
}, "getOrdersWithFiltersRequest").pipe(
  withDataAtom({ data: [], totalItems: 0 }),
  withAbort(),
  withIsLoadingAtom(),
);

export const getOrdersWithFiltersWithDebouncing = getOrdersWithFilters.pipe(
  withDebounce(200),
);
